import clsx from "clsx";
import { pages } from "data/links";
import Link from "next/link";
import React from "react";
import dynamic from "next/dynamic";

const ColorSchemeDropdown = dynamic(() => import("./ColorSchemeDropdown"), {
  ssr: false,
  loading: () => <div className="w-10" />,
});

const Panel = dynamic(() => import("./NavigationPanel"), {
  ssr: false,
  loading: () => <div className="w-10" />,
});

export const Navigation: React.FC = () => {
  return (
    <header
      className={clsx(
        "border-primary-12/10 bg-primary-1/70 text-primary-12 dark:border-primary-12/5 dark:bg-primary-2/70 sticky top-0 right-0 left-0 z-10 h-12 border-b transition-colors duration-300",
      )}
    >
      <div className="absolute inset-0 -z-10 backdrop-blur-md" />

      <nav className="container mx-auto flex h-full items-center pl-3 sm:pl-2">
        <Link href="/" className="font mr-auto text-3xl">
          IRISARCO
        </Link>

        <nav className="mr-4 hidden gap-3 sm:flex">
          {pages.map((p) => (
            <Link
              key={p.path}
              href={p.path}
              className="flex items-center gap-4 p-2 font-medium opacity-90"
            >
              {p.title}
            </Link>
          ))}
        </nav>

        <div className="mr-1 flex items-center gap-1">
          <ColorSchemeDropdown />
          <Panel />
        </div>
      </nav>
    </header>
  );
};
